export default __webpack_public_path__ + "static/media/maintenance-losses.0b2a9898.svg";